<template>
  <div id="pageRoot">
    <img
      id="arrows"
      class="pageElement"
      src="/pages/img/sordoglo/svgGlo27arrows.svg"
    />

    <span class="normalTheme pageInstruction" style="left: 60px; top: 118px">
      <p>Completa los recuadros con palabras de la misma familia.</p>
    </span>

    <span class="normalTheme pageInstruction" style="left: 60px; top: 400px">
      <p>Dibuja y sube fotos de tus dibujos.</p>
    </span>

    <h2 id="text01" class="textBase examples">SAPITO</h2>
    <h2 id="text02" class="textBase">SAPO</h2>
    <h2 id="text03" class="textBase examples">SAPÓN</h2>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      defaultText=""
      number="100"
      id="inputField01Disabled"
      class="pageElement"
      disabled
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      defaultText=""
      number="200"
      id="inputField02Disabled"
      class="pageElement"
      disabled
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
      class="pageElement"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
      class="pageElement"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="4"
      id="inputField04"
      class="pageElement"
    />

    <uploaded-image
      class="image01 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
    ></uploaded-image>
    <uploaded-image
      class="image02 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
    ></uploaded-image>

    <div
      id="button01"
      style="position: absolute; margin-left: 2.5%; margin-top: 65%; z-index: 5"
      class="pageElement"
    >
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="1"
        class="pageElement"
      ></image-upload>
    </div>
    <div
      id="button02"
      style="position: absolute; margin-left: 2.5%; margin-top: 65%; z-index: 5"
      class="pageElement"
    >
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="2"
        class="pageElement"
      ></image-upload>
    </div>
  </div>
</template>
<style scoped>
h2 {
  font-size: 30px;
}
.examples {
  font-style: italic;
  color: #00a5a5;
}
#arrows {
  position: absolute;
  left: 103px;
  top: 435px;
  z-index: 5;
}

#text01 {
  position: absolute;
  left: 176px;
  top: 172px;
  z-index: 1;
}
#text02 {
  position: absolute;
  left: 190px;
  top: 242px;
}
#text03 {
  position: absolute;
  left: 176px;
  top: 298px;
  z-index: 1;
}
#inputField01Disabled {
  position: absolute;
  width: 226px;
  height: 31px;
  left: 105px;
  top: 168px;
  z-index: 0;
}
#inputField02Disabled {
  position: absolute;
  width: 226px;
  height: 31px;
  left: 105px;
  top: 294px;
  z-index: 0;
}
#inputField01 {
  position: absolute;
  width: 226px;
  height: 31px;
  left: 394px;
  top: 168px;
}
#inputField02 {
  position: absolute;
  width: 226px;
  height: 31px;
  left: 674px;
  top: 168px;
}
#inputField03 {
  position: absolute;
  width: 226px;
  height: 31px;
  left: 394px;
  top: 294px;
}
#inputField04 {
  position: absolute;
  width: 226px;
  height: 31px;
  left: 674px;
  top: 294px;
}
.image01 {
  position: absolute;
  width: 400px;
  height: 266px;
  left: 104px;
  top: 448px;
}
.image02 {
  position: absolute;
  width: 400px;
  height: 266px;
  left: 547px;
  top: 448px;
}
#button01 {
  width: 216px;
  height: 77px;
  left: 250px;
  top: 10px;
}
#button02 {
  width: 216px;
  height: 77px;
  left: 693px;
  top: 10px;
}
</style>

<script>
import ImageUpload from "../../../components/ImageUpload.vue";
export default {
  name: "App",
  components: {
    ImageUpload,
  },
};
</script>